import { render, staticRenderFns } from "./MarketForm.vue?vue&type=template&id=5d7fece7&"
import script from "./MarketForm.vue?vue&type=script&lang=js&"
export * from "./MarketForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports